export const AUTH_FETCH='AUTH_FETCH';
export const AUTH_IS_FETCING='AUTH_IS_FETCHING';
export const AUTH_API='auth';



// WEBPACK FOOTER //
// ./src/constants/auth.js